export class WebhookV1StandardPayloadBackupJobRejectedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupJobRejected",
            "baseName": "backupJobRejected",
            "type": "WebhookV1BackupJobRejectedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobRejectedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
